import { render } from "./LegacyTriggerMailbox.vue?vue&type=template&id=3d401ff6"
import script from "./LegacyTriggerMailbox.vue?vue&type=script&lang=js"
export * from "./LegacyTriggerMailbox.vue?vue&type=script&lang=js"
script.render = render

export default script